module.exports = __webpack_public_path__ + "img/w-edit_task.d4dc694c.svg";